import { render, staticRenderFns } from "./QueryBindProductList.vue?vue&type=template&id=d25e4acc&scoped=true&"
import script from "./QueryBindProductList.vue?vue&type=script&lang=js&"
export * from "./QueryBindProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25e4acc",
  null
  
)

export default component.exports